/* Independent, progressively enhanced navigation. No cart or payment changes. */
(function () {
  'use strict';
  document.addEventListener('toggle', function (event) {
    var current = event.target;
    if (!(current instanceof HTMLElement) || !current.matches('[data-mt-disclosure]') || !current.open) return;
    document.querySelectorAll('[data-mt-disclosure][open]').forEach(function (other) { if (other !== current) other.open = false; });
    var search = current.querySelector('input[type="search"]');
    if (search) search.focus();
  }, true);
  // Keep new in-page links native, including focus and reduced-motion behaviour.
  // The legacy theme otherwise intercepts every anchor for a one-second animation.
  document.addEventListener('click', function (event) {
    var link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
    if (link && (link.matches('.mt-skip') || link.closest('.mt-home, .mt-coming'))) event.stopPropagation();
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mt-disclosure][open]').forEach(function (item) {
      item.open = false; var summary = item.querySelector('summary'); if (summary) summary.focus();
    });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-mt-disclosure][open]').forEach(function (item) {
      if (!item.contains(event.target)) item.open = false;
    });
  });
})();
